import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Bell, CircleHelp, ChevronDown, MessageCircle, Phone, LifeBuoy } from 'lucide-react';
import { CategoryIcon, IconButton, Popover, cn } from '@dd/ui';
import { useShop } from '@/hooks/useShop';
import { useT } from '@/lib/i18n';
import { SyncIndicator } from './SyncIndicator';
import { ShopSwitcher } from './ShopSwitcher';
import { useSupportContact, waLink, telLink } from '@/stores/support';
import { useUnread } from '@/features/notifications/useUnread';

export function TopBar() {
  const shop = useShop();
  const nav = useNavigate();
  const { t, lang } = useT();
  const [help, setHelp] = useState(false);
  const [switcher, setSwitcher] = useState(false);
  const contact = useSupportContact();
  const unread = useUnread();
  return (
    <>
      <header className="sticky top-0 z-30 flex items-center gap-2 border-b border-line bg-white px-3.5 pt-[calc(env(safe-area-inset-top,0px)+10px)] pb-2.5 shadow-[inset_0_-2px_0_var(--cat)] lg:px-8 lg:py-3.5">
        <button type="button" onClick={() => setSwitcher(true)} className="flex min-w-0 flex-1 items-center gap-2.5 rounded-xl py-1 pr-2 text-left active:bg-neutral-50 hover:bg-neutral-50/70 transition-colors" aria-label={t('দোকান ও প্রোফাইল', 'Shop & profile')}>
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-cat-soft"><CategoryIcon category={shop.category} size={20} /></span>
          <span className="min-w-0">
            <span className="block truncate text-[15px] font-bold leading-tight text-ink lg:text-base">{shop.name || '…'}</span>
            <span className="block truncate text-xs font-medium leading-tight text-cat-deep">{lang === 'bn' ? shop.cfg.labelBn : shop.cfg.labelEn}</span>
          </span>
          <ChevronDown size={16} className="shrink-0 text-ink-3" />
        </button>
        <SyncIndicator />
        <div className="relative">
          <IconButton label={t('সাহায্য', 'Help')} onClick={() => setHelp((v) => !v)}><CircleHelp size={22} /></IconButton>
          <Popover open={help} onClose={() => setHelp(false)} className="right-0 top-11">
            <a href={waLink(contact.whatsapp)} target="_blank" rel="noreferrer" className={helpRow}><MessageCircle size={18} className="text-wa" />WhatsApp</a>
            <a href={telLink(contact.phone)} className={helpRow}><Phone size={18} className="text-brand" />{t('ফোন করুন', 'Call us')}</a>
            <button type="button" className={cn(helpRow, 'w-full text-left')} onClick={() => { setHelp(false); nav('/help'); }}><LifeBuoy size={18} className="text-brand" />{t('সাহায্য ও সাপোর্ট', 'Help & support')}</button>
          </Popover>
        </div>
        <IconButton label={t('নোটিফিকেশন', 'Notifications')} onClick={() => nav('/notifications')} className="relative">
          <Bell size={22} />
          {unread > 0 && <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-bad px-1 text-[10px] font-bold text-white">{unread > 9 ? '9+' : unread}</span>}
        </IconButton>
      </header>
      <ShopSwitcher open={switcher} onClose={() => setSwitcher(false)} />
    </>
  );
}
const helpRow = 'flex items-center gap-3 rounded-xl px-3 py-2.5 text-[15px] font-medium text-ink hover:bg-neutral-50';
